import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { workoutAPI } from '../services/workoutAPI';

function SkipWorkoutModal({ program, nextWorkout, onClose, onSuccess }) {
  const [isSkipping, setIsSkipping] = useState(false);
  const [error, setError] = useState(null);

  const handleSkipWorkout = async () => {
    setError(null);
    setIsSkipping(true);

    try {
      // Update the current_workout_id to the next workout (without logging it)
      // This effectively marks it as "skipped"
      await workoutAPI.updateProgramProgress(program.id, nextWorkout.next_workout_id);
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error skipping workout:', err);
      setError('Failed to skip workout. Please try again.');
    } finally {
      setIsSkipping(false);
    }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Skip Workout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <Alert variant="warning" className="mb-3">
          <i className="fas fa-exclamation-triangle me-2"></i>
          <strong>Are you sure you want to skip this workout?</strong>
        </Alert>

        <p className="mb-3">
          You're about to skip: <strong>{nextWorkout?.next_workout_name || 'this workout'}</strong>
        </p>

        <div className="border rounded p-3 bg-light mb-3">
          <h6 className="mb-2">What happens when you skip:</h6>
          <ul className="mb-0 small">
            <li>This workout will be marked as complete without logging any exercises</li>
            <li>The next workout in your program will become available</li>
            <li>All scheduled dates remain unchanged</li>
            <li>This action cannot be undone</li>
          </ul>
        </div>

        <p className="mb-0 small text-muted">
          <i className="fas fa-info-circle me-1"></i>
          If you want to shift all future workouts forward, use the "Skip Days" button instead.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isSkipping}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSkipWorkout} disabled={isSkipping}>
          {isSkipping ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>
              Skipping...
            </>
          ) : (
            <>
              <i className="fas fa-step-forward me-2"></i>
              Skip Workout
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SkipWorkoutModal;
